import React, { useState, useEffect, useContext, useMemo, useRef } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import IpsaSidebarContext from '../context/SidebarContext'
import PresentationContext from '../pages/Ipsa/pages/Presentation/PresentationContext'

const HighchartsWrapper = ({ options, chartCallback = (e) => {}, printHeightPx = 300 }) => {
    const [internalChart, setInternatChart] = useState(null)
    const sidebarTransistionLength = 550

    const paddingAroundGraph = 20

    const { sidebarOpen, fullScreen } = useContext(IpsaSidebarContext)
    const {
        slider: { marginLeft, sliderWidth, setMarginLeft, setSliderWidth },
    } = useContext(PresentationContext)

    const reflowChart = (chart, timeout) => {
        setTimeout(() => {
            if (chart && chart.reflow) {
                chart.reflow()
                SetPaddingAndWidth()
            }
        }, timeout)
    }

    const SetPaddingAndWidth = () => {
        if (internalChart) {
            const { plotLeft, plotWidth, pointCount } = internalChart
            let columnWidth = 0
            let halfColumn = 0
            if (pointCount > 0) {
                columnWidth = plotWidth / pointCount
                halfColumn = columnWidth / 2
            }

            const newMarginLeft = plotLeft + paddingAroundGraph + halfColumn
            const newSliderWidth = plotWidth - columnWidth
            if (marginLeft !== newMarginLeft) {
                setMarginLeft(newMarginLeft)
            }
            if (sliderWidth !== newSliderWidth) {
                setSliderWidth(newSliderWidth)
            }
        }
    }

    const handlePrintBefore = () => {
        //set size chart, css was not working with chart resize
        if (internalChart) {
            //A4 landscape - 1123x794
            internalChart.setSize(1123 * 0.9, printHeightPx, false)
            // internalChart.reflow()
            // internalChart.print()
            // internalChart.setSize(null, null, false)
        }
    }

    const handlePrintAfter = () => {
        //cleanup
        if (internalChart) {
            internalChart.setSize(null, null, false)
            // reflowChart(internalChart, 200)
        }
    }

    useEffect(() => {
        if (internalChart) {
            window.addEventListener('beforeprint', handlePrintBefore)
            window.addEventListener('afterprint', handlePrintAfter)
            return function cleanup() {
                window.removeEventListener('beforeprint', handlePrintBefore)
                window.removeEventListener('afterprint', handlePrintAfter)
            }
        }
    }, [internalChart])

    useEffect(() => {
        reflowChart(internalChart, sidebarTransistionLength)
    }, [sidebarOpen])

    useEffect(() => {
        reflowChart(internalChart, 200)
    }, [fullScreen])

    useEffect(() => {
        SetPaddingAndWidth()
    })

    //only full rerender when options change (not context)
    return useMemo(() => {
        return (
            <div className="graph-container border-box">
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                    allowChartUpdate={true}
                    updateArgs={[true, true, true]}
                    callback={(e) => {
                        setInternatChart(e)
                        chartCallback(e)
                    }}
                    containerProps={{
                        style: { height: '100%', minHeight: '300px', width: '100%' },
                    }}
                />
            </div>
        )
    }, [options])
}

export default HighchartsWrapper
